import { SettingsBenefit } from '@spo/logic';
import { apiProductNatures } from '@spo/services/api';
import { useMutation } from '@tanstack/react-query';

export const usePatchProductNatureSettings = (
  segmentationTypeId: number | null,
  productBenefits: SettingsBenefit[],
  natureId: string,
  sportId: number,
  onSuccess: () => void,
) => {
  const benefitIds = productBenefits
    .map((benefit) => benefit.benefitId)
    .filter((id) => id !== null) as number[];

  return useMutation({
    mutationKey: ['usePatchProductNatureSettings', sportId, natureId],
    mutationFn: () =>
      apiProductNatures.setProductNatureSettings({
        segmentationTypeId,
        productBenefitIds: benefitIds,
        natureId,
        sportId,
        language: 'EN',
      }),
    onSuccess,
  });
};
